import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'vue-content-placeholders': true,
      'vue-content-placeholders-is-rounded': _ctx.rounded,
      'vue-content-placeholders-is-centered': _ctx.centered,
      'vue-content-placeholders-is-animated': _ctx.animated,
    })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}